var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-[0]",attrs:{"id":"map"}},[_c('div',{ref:"popup"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }